import api from 'js/api'
export const updateUserProfile = (data) =>
  api('PATCH', 'userprofile/v3/me', data)
